import type { IconData } from '@stacksjs/iconify-core'

export const phoneF: IconData = {
  "body": "<path fill=\"currentColor\" d=\"M3 .565h6a3 3 0 0 1 3 3v14a3 3 0 0 1-3 3H3a3 3 0 0 1-3-3v-14a3 3 0 0 1 3-3m3 17a1 1 0 1 0 0-2a1 1 0 0 0 0 2\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "0 0 24 24"
}

export default phoneF
